import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import ApiService from '../services/apiService';

/**
 * Console-only weight display - logs weight to browser console
 * No UI element, just background monitoring
 */
const WeightDisplayConsole = () => {
  const { state } = useAppContext();

  useEffect(() => {
    // Skip if weight monitoring is disabled
    if (state.settings.disableWeightMonitoring) {
      console.log('🔧 WeightDisplayConsole: Weight monitoring is disabled');
      return;
    }

    console.log('🔧 WeightDisplayConsole: Starting weight monitoring...');

    const fetchWeight = async () => {
      try {
        const response = await ApiService.getWeight();

        if (response.success) {
          console.log('⚖️  SCALE WEIGHT:', {
            item_weight: `${(response.accumulated_weight || 0).toFixed(1)}g`,
            total_weight: `${(response.current_weight || 0).toFixed(1)}g`,
            tray_weight: `${(response.baseline_weight || 0).toFixed(1)}g`,
            stable: response.is_stable ? '✅ Stable' : '⏳ Reading...',
            timestamp: new Date().toLocaleTimeString()
          });
        } else {
          console.warn('⚖️  Scale not connected:', response.error);
        }
      } catch (error) {
        console.error('⚖️  Failed to fetch weight:', error);
      }
    };

    // Initial fetch
    fetchWeight();

    // Poll every 2 seconds (easier to read in console)
    const interval = setInterval(fetchWeight, 2000);

    return () => {
      console.log('🔧 WeightDisplayConsole: Stopping weight monitoring');
      clearInterval(interval);
    };
  }, [state.settings.disableWeightMonitoring]);

  // No visual component - returns null
  return null;
};

export default WeightDisplayConsole;
